module.exports = __webpack_public_path__ + "img/Book.40b84415.svg";